import { Container, Row } from 'reactstrap'
import EditMyProfile from './EditMyProfile/EditMyProfile'
import EditProfileForm from './EditProfileForm/EditProfileForm'
// import AddProjectsAndUpload from './AddProjectsAndUpload/AddProjectsAndUpload'
import Breadcrumbs from '../../../../CommonElements/Breadcrumbs/Breadcrumbs'
import { Users } from '../../../../utils/Constant'
import { useTranslation } from 'react-i18next'

const EditProfileContainer = () => {
  const { t } = useTranslation();
  return (
    <>
      <Breadcrumbs mainTitle={t("Editar Perfil")} parent={Users} />
      <Container fluid>
        <div className="edit-profile">
          <Row>
            <EditMyProfile />
            <EditProfileForm />
            {/* <AddProjectsAndUpload /> */}
          </Row>
        </div>
      </Container>
    </>
  )
}

export default EditProfileContainer